import React from 'react';
import './signature.styles.scss';

export default function SignatureForm({
  signedImg,
  title = 'Headteacher/Principal/Director',
}) {
  return (
    <div className="signature">
      <div
        style={{
          display: 'flex',
          gap: '10px',
          flexWrap: 'wrap',
          alignItems: 'end',
        }}
      >
        <p>Signed</p>
        <div style={{ display: 'grid' }}>
          {signedImg && (
            <img
              src={signedImg}
              alt="Digital Signature"
              style={{
                objectFit: 'contain',
                height: '50px',
                width: '200px',
              }}
            />
          )}
          <span className="line"></span>
        </div>
      </div>
      <span style={{ wordBreak: 'break-word' }}>{title}</span>
    </div>
  );
}
